import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { AppFrameSplit, AppFrameStyle } from "./AppFrameStyle";

// AppFrameSheet - the contact frame's stylesheets as `blob:` URLs of our own (2026-09-27). The rules of the
// rewrite are `AppFrameStyle` (no habitat, so the Bridge suite can drive it with real pages); this is the
// one place that mints and releases the URLs.
//
// ⚠ A SHEET'S URL LIVES AS LONG AS ITS FRAME - AND ONE PAGE LONGER (2026-09-28): a jump inside the page (`#m-...`),
// a reload of the same `blob:` document or a history step reads the sheets again, so a page's URLs are released
// only when the page AFTER the next one is built. The frame that was just replaced may still be finishing a load.
// ⭐ The CSS TEXT of the current page is kept too (`Texts`): `AppFrameHeal` installs it through the CSSOM when a
// linked sheet did not apply (a policy from another build, a revoked or refused `blob:`), see its header.

export class AppFrameSheet {
    /** The current page's sheets, in order: their `blob:` URLs and their CSS. */
    private Urls: string[] = [];
    private Css: string[] = [];
    /** The page before it - released when the next page is built, not before. */
    private Older: string[] = [];

    /** The page's markup with every inline style moved into linked sheets; the page before last's sheets go. */
    public Page = (Html: string, Extra: string): string => {
        if (getCoreUtils().KErrorMode === true) { return Html; }
        try {
            this.Release();
            const Split: AppFrameSplit = AppFrameStyle.Split(Html, Extra);
            this.Css = Split.Sheets.slice();
            for (const Css of Split.Sheets) {
                this.Urls.push(URL.createObjectURL(new Blob([Css], { type: "text/css" })));
            }
            return AppFrameStyle.Join(Split, this.Urls);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppFrameSheet.Page");
            return Html;
        }
    };

    /** The current page's sheet URLs, in order (a copy). DOCUMENTED EXCEPTION: a copy. ERROR-SUPPRESSED-JUSTIFIED: cannot throw. */
    public Hrefs = (): string[] => {
        return this.Urls.slice();
    };

    /** The current page's CSS, in order (a copy). DOCUMENTED EXCEPTION: a copy. ERROR-SUPPRESSED-JUSTIFIED: cannot throw. */
    public Texts = (): string[] => {
        return this.Css.slice();
    };

    /** Frees the page before last's URLs; the current page's become the older generation. */
    public Release = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            for (const Url of this.Older) { URL.revokeObjectURL(Url); }
            this.Older = this.Urls;
            this.Urls = [];
            this.Css = [];
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppFrameSheet.Release");
        }
    };
}
